import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {ProductoPasarelaTarifa} from '../_models/producto-pasarela-tarifa';

@Injectable({
  providedIn: 'root'
})
export class ProductoPasarelaTarifaService {
  private route: string = `${AppSettings.rutServiciosAPL}/api/productosPasarelasTarifas`;

  constructor(
    private httpClient: HttpClient,
    private authService: AutenticacionService
  ) {}

  getAll(): Observable<ProductoPasarelaTarifa[]> {
    return this.httpClient.get<ProductoPasarelaTarifa[]>(this.route);
  }

  getAllEnabled(): Observable<ProductoPasarelaTarifa[]> {
    return this.httpClient.get<ProductoPasarelaTarifa[]>(`${this.route}/enabled}`);
  }

  getById(id: string): Observable<ProductoPasarelaTarifa[]> {
    return this.httpClient.get<ProductoPasarelaTarifa[]>(`${this.route}/${id}`);
  }

  getByIdProductoPasarela(id: string): Observable<ProductoPasarelaTarifa[]> {
    return this.httpClient.get<ProductoPasarelaTarifa[]>(`${this.route}/productoPasarela/${id}`);
  }

  getByIdProductoPasarelaEnabled(id: string): Observable<ProductoPasarelaTarifa[]> {
    return this.httpClient.get<ProductoPasarelaTarifa[]>(`${this.route}/productoPasarela/${id}/enabled`);
  }

  getByIdsProductosPasarela(ids: string[]): Observable<ProductoPasarelaTarifa[]> {
    return this.httpClient.post<ProductoPasarelaTarifa[]>(`${this.route}/idProductoPasarelaIn`, ids);
  }

  create(record: ProductoPasarelaTarifa): Observable<ProductoPasarelaTarifa> {
    record.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoPasarelaTarifa>(this.route, record);
  }

  update(record: ProductoPasarelaTarifa): Observable<ProductoPasarelaTarifa> {
    record.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoPasarelaTarifa>(this.route, record);
  }

  createBulk(records: ProductoPasarelaTarifa[]): Observable<ProductoPasarelaTarifa[]> {
    records.forEach((e: ProductoPasarelaTarifa) => e.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoPasarelaTarifa[]>(`${this.route}/bulk`, records);
  }

  updateBulk(records: ProductoPasarelaTarifa[]): Observable<ProductoPasarelaTarifa[]> {
    records.forEach((e: ProductoPasarelaTarifa) => e.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.put<ProductoPasarelaTarifa[]>(`${this.route}/bulk`, records);
  }
}
